import { getHelpCenterAri } from '@helpcenter/meta';
import { createResource, type RouterDataContext } from 'react-resource-router';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';
import { fetchJson } from '@atlassian/help-center-common-util/fetch/fetch';
import type { RequestConversationResource } from './types';

export const requestConversationResource = createResource<RequestConversationResource>({
	type: 'REQUEST_CONVERSATION_RESOURCE',
	getKey: () => `request-conversation`,
	getData: async ({ match }: RouterDataContext) => {
		const { helpCenterId } = HelpHelpCenterAri.parse(getHelpCenterAri());
		return fetchJson(
			`/gateway/api/jsm/csm/api/v1/request/form/helpcenter/${helpCenterId}/conversation/history?issueIdOrKey=${
				match.params.requestKey || ''
			}`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			},
		);
	},
	maxAge: 0,
});
